import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0f82aa68 = () => interopDefault(import('../pages/actions/index.vue' /* webpackChunkName: "pages/actions/index" */))
const _dabc9e82 = () => interopDefault(import('../pages/ads/index.vue' /* webpackChunkName: "pages/ads/index" */))
const _71fd871a = () => interopDefault(import('../pages/brands/index.vue' /* webpackChunkName: "pages/brands/index" */))
const _532b2bc7 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _08f08ee8 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _5b49e138 = () => interopDefault(import('../pages/collections/index.vue' /* webpackChunkName: "pages/collections/index" */))
const _56ab3e4c = () => interopDefault(import('../pages/company/index.vue' /* webpackChunkName: "pages/company/index" */))
const _58d84698 = () => interopDefault(import('../pages/compare/index.vue' /* webpackChunkName: "pages/compare/index" */))
const _575b401c = () => interopDefault(import('../pages/delete-account/index.vue' /* webpackChunkName: "pages/delete-account/index" */))
const _ef06cfde = () => interopDefault(import('../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _3ad8b2e1 = () => interopDefault(import('../pages/gallery/index.vue' /* webpackChunkName: "pages/gallery/index" */))
const _1660eab0 = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _7639fbd5 = () => interopDefault(import('../pages/info/index.vue' /* webpackChunkName: "pages/info/index" */))
const _24886738 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _4aefd29e = () => interopDefault(import('../pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _535277ba = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _40f724dd = () => interopDefault(import('../pages/order/index.vue' /* webpackChunkName: "pages/order/index" */))
const _6457c8e7 = () => interopDefault(import('../pages/personal/index.vue' /* webpackChunkName: "pages/personal/index" */))
const _4468d70b = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _dd72da4e = () => interopDefault(import('../pages/stores/index.vue' /* webpackChunkName: "pages/stores/index" */))
const _067cddca = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _125a2e6c = () => interopDefault(import('../pages/company/about/index.vue' /* webpackChunkName: "pages/company/about/index" */))
const _370a5e0c = () => interopDefault(import('../pages/company/contacts/index.vue' /* webpackChunkName: "pages/company/contacts/index" */))
const _7661b9da = () => interopDefault(import('../pages/company/requisites/index.vue' /* webpackChunkName: "pages/company/requisites/index" */))
const _0d40029e = () => interopDefault(import('../pages/order/pay-error/index.vue' /* webpackChunkName: "pages/order/pay-error/index" */))
const _446405ae = () => interopDefault(import('../pages/order/pay-ok/index.vue' /* webpackChunkName: "pages/order/pay-ok/index" */))
const _3bb176b6 = () => interopDefault(import('../pages/order/pay/index.vue' /* webpackChunkName: "pages/order/pay/index" */))
const _56b863c8 = () => interopDefault(import('../pages/personal/ads/index.vue' /* webpackChunkName: "pages/personal/ads/index" */))
const _6fd13565 = () => interopDefault(import('../pages/personal/bonuses/index.vue' /* webpackChunkName: "pages/personal/bonuses/index" */))
const _10a99aba = () => interopDefault(import('../pages/personal/orders/index.vue' /* webpackChunkName: "pages/personal/orders/index" */))
const _5be90b01 = () => interopDefault(import('../pages/personal/profile/index.vue' /* webpackChunkName: "pages/personal/profile/index" */))
const _62858ef3 = () => interopDefault(import('../pages/personal/reviews/index.vue' /* webpackChunkName: "pages/personal/reviews/index" */))
const _338fa64c = () => interopDefault(import('../pages/personal/ads/add/index.vue' /* webpackChunkName: "pages/personal/ads/add/index" */))
const _1018f5bd = () => interopDefault(import('../pages/personal/orders/__id/index.vue' /* webpackChunkName: "pages/personal/orders/__id/index" */))
const _6149e017 = () => interopDefault(import('../pages/personal/ads/__id/edit/index.vue' /* webpackChunkName: "pages/personal/ads/__id/edit/index" */))
const _7ee72f34 = () => interopDefault(import('../pages/actions/__id/index.vue' /* webpackChunkName: "pages/actions/__id/index" */))
const _1148e921 = () => interopDefault(import('../pages/ads/__id/index.vue' /* webpackChunkName: "pages/ads/__id/index" */))
const _25108ded = () => interopDefault(import('../pages/brands/__id/index.vue' /* webpackChunkName: "pages/brands/__id/index" */))
const _2232a5a8 = () => interopDefault(import('../pages/catalog/__slug/index.vue' /* webpackChunkName: "pages/catalog/__slug/index" */))
const _95ec3ca8 = () => interopDefault(import('../pages/collections/__slug/index.vue' /* webpackChunkName: "pages/collections/__slug/index" */))
const _4e71c78f = () => interopDefault(import('../pages/gallery/__slug/index.vue' /* webpackChunkName: "pages/gallery/__slug/index" */))
const _7074f1e8 = () => interopDefault(import('../pages/help/__slug/index.vue' /* webpackChunkName: "pages/help/__slug/index" */))
const _0b2e441b = () => interopDefault(import('../pages/info/__slug/index.vue' /* webpackChunkName: "pages/info/__slug/index" */))
const _6b1771f4 = () => interopDefault(import('../pages/news/__id/index.vue' /* webpackChunkName: "pages/news/__id/index" */))
const _848c5b56 = () => interopDefault(import('../pages/products/__id/index.vue' /* webpackChunkName: "pages/products/__id/index" */))
const _6cbf4747 = () => interopDefault(import('../pages/stores/__id/index.vue' /* webpackChunkName: "pages/stores/__id/index" */))
const _76e4295e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/actions/",
    component: _0f82aa68,
    pathToRegexpOptions: {"strict":true},
    name: "actions"
  }, {
    path: "/ads/",
    component: _dabc9e82,
    pathToRegexpOptions: {"strict":true},
    name: "ads"
  }, {
    path: "/brands/",
    component: _71fd871a,
    pathToRegexpOptions: {"strict":true},
    name: "brands"
  }, {
    path: "/cart/",
    component: _532b2bc7,
    pathToRegexpOptions: {"strict":true},
    name: "cart"
  }, {
    path: "/catalog/",
    component: _08f08ee8,
    pathToRegexpOptions: {"strict":true},
    name: "catalog"
  }, {
    path: "/collections/",
    component: _5b49e138,
    pathToRegexpOptions: {"strict":true},
    name: "collections"
  }, {
    path: "/company/",
    component: _56ab3e4c,
    pathToRegexpOptions: {"strict":true},
    name: "company"
  }, {
    path: "/compare/",
    component: _58d84698,
    pathToRegexpOptions: {"strict":true},
    name: "compare"
  }, {
    path: "/delete-account/",
    component: _575b401c,
    pathToRegexpOptions: {"strict":true},
    name: "delete-account"
  }, {
    path: "/favourites/",
    component: _ef06cfde,
    pathToRegexpOptions: {"strict":true},
    name: "favourites"
  }, {
    path: "/gallery/",
    component: _3ad8b2e1,
    pathToRegexpOptions: {"strict":true},
    name: "gallery"
  }, {
    path: "/help/",
    component: _1660eab0,
    pathToRegexpOptions: {"strict":true},
    name: "help"
  }, {
    path: "/info/",
    component: _7639fbd5,
    pathToRegexpOptions: {"strict":true},
    name: "info"
  }, {
    path: "/login/",
    component: _24886738,
    pathToRegexpOptions: {"strict":true},
    name: "login"
  }, {
    path: "/logout/",
    component: _4aefd29e,
    pathToRegexpOptions: {"strict":true},
    name: "logout"
  }, {
    path: "/news/",
    component: _535277ba,
    pathToRegexpOptions: {"strict":true},
    name: "news"
  }, {
    path: "/order/",
    component: _40f724dd,
    pathToRegexpOptions: {"strict":true},
    name: "order"
  }, {
    path: "/personal/",
    component: _6457c8e7,
    pathToRegexpOptions: {"strict":true},
    name: "personal"
  }, {
    path: "/products/",
    component: _4468d70b,
    pathToRegexpOptions: {"strict":true},
    name: "products"
  }, {
    path: "/stores/",
    component: _dd72da4e,
    pathToRegexpOptions: {"strict":true},
    name: "stores"
  }, {
    path: "/video/",
    component: _067cddca,
    pathToRegexpOptions: {"strict":true},
    name: "video"
  }, {
    path: "/company/about/",
    component: _125a2e6c,
    pathToRegexpOptions: {"strict":true},
    name: "company-about"
  }, {
    path: "/company/contacts/",
    component: _370a5e0c,
    pathToRegexpOptions: {"strict":true},
    name: "company-contacts"
  }, {
    path: "/company/requisites/",
    component: _7661b9da,
    pathToRegexpOptions: {"strict":true},
    name: "company-requisites"
  }, {
    path: "/order/pay-error/",
    component: _0d40029e,
    pathToRegexpOptions: {"strict":true},
    name: "order-pay-error"
  }, {
    path: "/order/pay-ok/",
    component: _446405ae,
    pathToRegexpOptions: {"strict":true},
    name: "order-pay-ok"
  }, {
    path: "/order/pay/",
    component: _3bb176b6,
    pathToRegexpOptions: {"strict":true},
    name: "order-pay"
  }, {
    path: "/personal/ads/",
    component: _56b863c8,
    pathToRegexpOptions: {"strict":true},
    name: "personal-ads"
  }, {
    path: "/personal/bonuses/",
    component: _6fd13565,
    pathToRegexpOptions: {"strict":true},
    name: "personal-bonuses"
  }, {
    path: "/personal/orders/",
    component: _10a99aba,
    pathToRegexpOptions: {"strict":true},
    name: "personal-orders"
  }, {
    path: "/personal/profile/",
    component: _5be90b01,
    pathToRegexpOptions: {"strict":true},
    name: "personal-profile"
  }, {
    path: "/personal/reviews/",
    component: _62858ef3,
    pathToRegexpOptions: {"strict":true},
    name: "personal-reviews"
  }, {
    path: "/personal/ads/add/",
    component: _338fa64c,
    pathToRegexpOptions: {"strict":true},
    name: "personal-ads-add"
  }, {
    path: "/personal/orders/:_id/",
    component: _1018f5bd,
    pathToRegexpOptions: {"strict":true},
    name: "personal-orders-_id"
  }, {
    path: "/personal/ads/:_id/edit/",
    component: _6149e017,
    pathToRegexpOptions: {"strict":true},
    name: "personal-ads-_id-edit"
  }, {
    path: "/actions/:_id/",
    component: _7ee72f34,
    pathToRegexpOptions: {"strict":true},
    name: "actions-_id"
  }, {
    path: "/ads/:_id/",
    component: _1148e921,
    pathToRegexpOptions: {"strict":true},
    name: "ads-_id"
  }, {
    path: "/brands/:_id/",
    component: _25108ded,
    pathToRegexpOptions: {"strict":true},
    name: "brands-_id"
  }, {
    path: "/catalog/:_slug/",
    component: _2232a5a8,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-_slug"
  }, {
    path: "/collections/:_slug/",
    component: _95ec3ca8,
    pathToRegexpOptions: {"strict":true},
    name: "collections-_slug"
  }, {
    path: "/gallery/:_slug/",
    component: _4e71c78f,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-_slug"
  }, {
    path: "/help/:_slug/",
    component: _7074f1e8,
    pathToRegexpOptions: {"strict":true},
    name: "help-_slug"
  }, {
    path: "/info/:_slug/",
    component: _0b2e441b,
    pathToRegexpOptions: {"strict":true},
    name: "info-_slug"
  }, {
    path: "/news/:_id/",
    component: _6b1771f4,
    pathToRegexpOptions: {"strict":true},
    name: "news-_id"
  }, {
    path: "/products/:_id/",
    component: _848c5b56,
    pathToRegexpOptions: {"strict":true},
    name: "products-_id"
  }, {
    path: "/stores/:_id/",
    component: _6cbf4747,
    pathToRegexpOptions: {"strict":true},
    name: "stores-_id"
  }, {
    path: "/",
    component: _76e4295e,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
